import { useEffect, useState } from "react";

export function useOpenGameTimers(game) {
    const [  gameStartSeconds,   setGameStartSeconds] = useState(null);
    const [gameExpiresSeconds, setGameExpiresSeconds] = useState(null);

    useEffect(() => {
        if (!game || !game.isOpenGame) {
            setGameStartSeconds(null);
            setGameExpiresSeconds(null);
            return () => {};
        }

        const gameStartsAt = game.openGameStartsAt ? new Date(game.openGameStartsAt) : null;
        const gameExpiresAt = game.expiresAt ? new Date(game.expiresAt) : null;

        const interval = setInterval(() => {
            if (gameStartsAt !== null) {
                if ((gameStartsAt.getTime() - Date.now()) / 1000 <= 0) {
                    setGameStartSeconds(0);
                } else {
                    setGameStartSeconds((gameStartsAt.getTime() - Date.now()) / 1000);
                }
            }

            if (gameExpiresAt !== null) {
                if ((gameExpiresAt.getTime() - Date.now()) / 1000 <= 0) {
                    setGameExpiresSeconds(0);
                } else {
                    setGameExpiresSeconds((gameExpiresAt.getTime() - Date.now()) / 1000);
                }
            }
        }, 1000);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [game?.isOpenGame, game?.openGameStartsAt, game?.createdAt]);

    return {
        gameStartSeconds,
        gameExpiresSeconds
    };
}

export function secondsAsTimer(inputSeconds, maxUnit) {
    if (maxUnit === "minutes") {
        const timerMinutes = Math.floor(inputSeconds / 60);
        const timerSeconds = Math.floor(inputSeconds % 60);
        return { minutes: timerMinutes, seconds: timerSeconds };
    } else if (maxUnit === "hours") {
        const timerHours = Math.floor(inputSeconds / 3600);
        const timerMinutes = Math.floor((inputSeconds % 3600) / 60);
        const timerSeconds = Math.floor(inputSeconds % 60);
        return { hours: timerHours, minutes: timerMinutes, seconds: timerSeconds };
    } else {
        throw new Error("Invalid maxUnit: " + maxUnit);
    }
}

export function timerString(segments, opts = { padLen: 2 }) {
    let output = "";

    for (const segment of segments) {
        let value = `${segment}`;
        if (opts?.padLen) {
            value = value.padStart(opts.padLen, opts.padChar ?? "0");
        }

        if (output.length > 0) {
            output += ":";
        }
        output += value;
    }

    return output;
}